export default "/images/background.png?8d41287ccbcb2aa31b1a55a9aed4631c";